import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Language, getDirection, getFontClass } from './thi-translations';
import { normalizeThiLang } from './thi-lang.util';

/**
 * Standard wrapper for Lovable-style THI marketing pages: header + projected body + footer.
 */
@Component({
  selector: 'app-thi-page-shell',
  templateUrl: './thi-page-shell.component.html',
  styleUrls: ['./thi-page-shell.component.scss'],
})
export class ThiPageShellComponent implements OnChanges {
  @Input() lang: Language = 'ar';

  dir: 'rtl' | 'ltr' = 'rtl';
  fontClass = 'font-cairo';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lang']) {
      const l = normalizeThiLang(this.lang as unknown as string);
      this.lang = l;
      this.dir = getDirection(l);
      this.fontClass = getFontClass(l);
    }
  }
}
